import React from 'react'
import { Link } from 'react-router-dom';

function Table(props) {

	function nFormatter(num) {
		if (num >= 1000000000000) {
		   return (num / 1000000000000).toFixed(2).replace(/\.0$/, '') + 'T';
		}
		if (num >= 1000000000) {
		   return (num / 1000000000).toFixed(2).replace(/\.0$/, '') + 'B';
		}
		if (num >= 1000000) {
		   return (num / 1000000).toFixed(2).replace(/\.0$/, '') + 'M';
		}
		if (num >= 1000) {
		   return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
		}
		return num;
	   }

  return (
   
<div class="overflow-x-auto relative md:pt-4 shadow-md sm:rounded-lg">
    <table class="w-full text-sm text-center text-gray-500 dark:text-gray-400">
    <caption>
	Last updated yesterday
    </caption>
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>

                <th scope="col" className="py-3 px-6">
                </th>
                <th scope="col" className="py-3 px-6">
                    Company
                </th>
                <th scope="col" className="py-3 px-6">
                    Market State
                </th>
                <th scope="col" className="py-3 px-6">
                    Market Cap
                </th>
                <th scope="col" className="py-3 px-6">
                    Volume
                </th>
                <th scope="col" className="py-3 px-6">
                    Currency
                </th>
                <th scope="col" className="py-3 px-6">
                    Regular Market Price
                </th>
                <th scope="col" className="py-3 px-6">
                    Book Price
                </th>
                <th scope="col" className="py-3 px-6">
                    Outstanding Shares
                </th>
                <th scope="col" className="py-3 px-6">
                    Exchange
                </th>
                <th scope="col" className="py-3 px-6">
                    Price Hint
                </th>
            </tr>
        </thead>
        <tbody>
			{Object.keys(props).map((keyName,i) => (
	<tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
	     	<th scope='row' className="py-4 px-6">{i+1}</th>
		<Link style={{textDecoration:'none'}} className="text-green-500" to={`/stocks/${keyName}`}>
                <td className="py-4 px-6 font-medium text-gray-900 hover:text-green-600 whitespace-nowrap dark:text-white">{keyName}</td>
		</Link>
		<td className="py-4 px-6">{[props?.[keyName]?.marketState]}</td>
		<td className="py-4 px-6">{nFormatter([props?.[keyName]?.marketCap])}</td>
		<td className="py-4 px-6">{nFormatter([props?.[keyName]?.regularMarketVolume])}</td>
		<td className="py-4 px-6">{[props?.[keyName]?.currency]}-{[props?.[keyName]?.quoteType]}</td>
		<td className="py-4 px-6">{[props?.[keyName]?.priceToBook]}</td>
		<td className="py-4 px-6"> {[props?.[keyName]?.regularMarketPrice]}</td>
		<td className="py-4 px-6"> {[props?.[keyName]?.sharesOutstanding]}</td>
		<td className="py-4 px-6"> {[props?.[keyName]?.fullExchangeName]}</td>
		<td className="py-4 px-6"> {[props?.[keyName]?.priceHint]}</td>
	</tr>
			))}
        </tbody>
    </table>
</div>


  )
}

export default Table